var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_637_2090)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.504639,
    y: 0.223633,
    width: 72,
    height: 72,
    rx: 24,
    fill: "url(#paint0_linear_637_2090)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.754639,
    y: 0.473633,
    width: 71.5,
    height: 71.5,
    rx: 23.75,
    stroke: "url(#paint1_linear_637_2090)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5052 60.2236C36.3944 60.2236 36.2835 60.1981 36.1812 60.1497C35.9539 60.0417 30.5769 57.4641 25.1061 53.2551C21.8748 50.7713 19.2943 48.2334 17.4385 45.7154C15.0711 42.5097 13.8718 39.3153 13.8718 36.2233V15.9743C13.8718 15.7526 13.9685 15.5452 14.139 15.4031C14.3066 15.2581 14.5283 15.1985 14.7471 15.2326C18.6804 15.8663 22.662 15.8663 26.5782 15.2326C29.8976 14.6954 33.1289 13.7064 36.1897 12.294C36.3887 12.2002 36.6217 12.2002 36.8235 12.294C39.8843 13.7064 43.1156 14.6954 46.435 15.2326C50.3512 15.8663 54.3328 15.8663 58.2661 15.2326C58.4849 15.1985 58.7066 15.2581 58.8743 15.4031C59.0419 15.5452 59.1414 15.7526 59.1414 15.9743V36.2233C59.1414 39.3153 57.9421 42.5097 55.5747 45.7154C53.7189 48.2334 51.1384 50.7713 47.9071 53.2551C42.4364 57.4641 37.0594 60.0417 36.832 60.1497C36.7297 60.1981 36.6189 60.2236 36.5052 60.2236ZM15.3809 16.8439V36.2233C15.3809 42.5523 21.1728 48.3329 26.0297 52.07C30.6195 55.6026 35.2576 58.0097 36.5052 58.635C37.7585 58.0097 42.4108 55.5912 47.0034 52.053C51.8518 48.3215 57.6323 42.5438 57.6323 36.2233V16.8439C53.8241 17.3697 49.9789 17.3271 46.1934 16.7132C42.8541 16.1732 39.5944 15.1928 36.5052 13.7974C33.416 15.1928 30.1591 16.1732 26.8198 16.7132C23.0343 17.3271 19.1891 17.3697 15.3809 16.8439Z",
    fill: "#32BE71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5041 56.4715C36.3961 56.4715 36.2881 56.4488 36.1858 56.4005C35.9926 56.3124 31.346 54.144 26.6198 50.6086C23.8261 48.5197 21.5952 46.3826 19.9895 44.2625C17.9319 41.5512 16.8889 38.8457 16.8889 36.2226V19.239C16.8889 19.0202 16.9855 18.8099 17.1532 18.6678C17.3209 18.5257 17.5426 18.4632 17.7614 18.4973C21.1433 19.0287 24.5651 19.0287 27.9328 18.4973C30.7861 18.0482 33.5655 17.2212 36.1944 16.039C36.3933 15.9509 36.6178 15.9509 36.8167 16.039C39.4456 17.2212 42.225 18.0482 45.0783 18.4973C48.446 19.0287 51.8678 19.0287 55.2497 18.4973C55.4685 18.4632 55.6902 18.5257 55.8579 18.6678C56.0256 18.8099 56.1222 19.0202 56.1222 19.239V36.2226C56.1222 38.8457 55.0792 41.5512 53.0216 44.2625C51.4159 46.3826 49.185 48.5197 46.3913 50.6086C41.6651 54.144 37.0185 56.3095 36.8253 56.4005C36.723 56.4488 36.615 56.4715 36.5041 56.4715ZM18.398 20.1058V36.2226C18.398 45.6408 34.0572 53.6893 36.5041 54.8886C38.9539 53.6893 54.6131 45.6408 54.6131 36.2226V20.1058C51.3591 20.5293 48.0766 20.4895 44.8424 19.9779C41.9692 19.5261 39.1642 18.7076 36.5041 17.5424C33.8469 18.7076 31.0419 19.5261 28.1687 19.9779C24.9345 20.4895 21.652 20.5293 18.398 20.1058Z",
    fill: "#32BE71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.373 42.8045C34.1798 42.8045 33.9865 42.7335 33.8387 42.5857L28.5044 37.2826C28.2088 36.9899 28.2088 36.5153 28.5044 36.2226L30.6387 34.0996C30.7779 33.9604 30.9712 33.8808 31.1701 33.8808C31.3719 33.8808 31.5623 33.9604 31.7044 34.0996L34.373 36.7512L41.3074 29.8594C41.603 29.5667 42.0804 29.5639 42.3731 29.8594L44.5074 31.9795C44.6495 32.1188 44.7291 32.312 44.7291 32.511C44.7291 32.7099 44.6495 32.9003 44.5074 33.0396L34.9045 42.5857C34.7567 42.7335 34.5663 42.8045 34.373 42.8045ZM30.1044 36.7512L34.373 40.9942L42.9074 32.511L41.8417 31.4481L34.9045 38.3427C34.7652 38.4848 34.572 38.5643 34.373 38.5643C34.1712 38.5643 33.9808 38.4848 33.8387 38.3427L31.1701 35.6911L30.1044 36.7512Z",
    fill: "#32BE71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5041 48.222C29.8483 48.222 24.4343 42.8394 24.4343 36.2233C24.4343 29.6072 29.8483 24.2217 36.5041 24.2217C43.1628 24.2217 48.5768 29.6072 48.5768 36.2233C48.5768 42.8394 43.1628 48.222 36.5041 48.222ZM36.5041 25.7222C30.681 25.7222 25.9434 30.4342 25.9434 36.2233C25.9434 42.0124 30.681 46.7215 36.5041 46.7215C42.3301 46.7215 47.0677 42.0124 47.0677 36.2233C47.0677 30.4342 42.3301 25.7222 36.5041 25.7222Z",
    fill: "#32BE71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_637_2090",
    x: -19.4954,
    y: -19.7764,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_637_2090"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_637_2090",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_637_2090",
    x1: 36.5046,
    y1: 0.223633,
    x2: 36.5046,
    y2: 72.2236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_637_2090",
    x1: 36.5046,
    y1: 0.223633,
    x2: 36.5046,
    y2: 72.2236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.d3b29e52a96c465d667386c00f4e7b60.svg";
export { ForwardRef as ReactComponent };